import { useLocation, useNavigate } from "react-router";

import { useAllTools } from "~api/tools.ts";
import { ROUTES } from "~components/routeDefinitions.ts";
import { Priority } from "~components/shared/TaskBar/TaskBar.tsx";
import { useCurrentEmployee } from "~contexts/CurrentEmployeeContext/CurrentEmployeeContext";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import { Tool } from "~generated";

export function useToolAdministrationTaskBar() {
  const { currentEmployee } = useCurrentEmployee();
  const navigate = useNavigate();
  const location = useLocation();
  const { number: tenantNumber } = useCurrentTenant();
  const { data: allTools } = useAllTools({});

  const assignedToolTaskCount =
    allTools?.tools.filter(
      (tool) =>
        tool.active &&
        tool.responsibility_state === Tool.responsibility_state.ASSIGNED &&
        tool.responsible_employee_id === currentEmployee?.id,
    ).length || 0;

  const navigateToToolAdministrationTask = async (taskType: string) => {
    const path = ROUTES.tools.link({ tenantNumber });
    await navigate(`${path}?taskType=${taskType}`, {
      replace: location.pathname === path,
    });
  };

  return {
    assignedToolTaskCount,
    assignedToolTaskPriority:
      assignedToolTaskCount === 0 ? Priority.NORMAL : Priority.MEDIUM,
    hasTasks: assignedToolTaskCount > 0,
    navigateToAssignedToolTask: () =>
      navigateToToolAdministrationTask("assigned"),
  };
}
